module.exports = __webpack_public_path__ + "fa-solid-900.woff?a7140145ebaaf5fb14e40430af5d25c4";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff
// module id = 220
// module chunks = 0